if (!customElements.get('product-accessories')) {
  customElements.define(
    'product-accessories',
    class ProductAccessories extends HTMLElement {
      connectedCallback() {
        this._onSubmit = this._handleFormSubmit.bind(this);
        // Document-level capture fires before any element-level listeners,
        // allowing us to intercept the form submit and add all items in one request.
        document.addEventListener('submit', this._onSubmit, { capture: true });

        this.querySelectorAll('.accessory-variant-select').forEach((sel) => {
          sel.addEventListener('change', this._onVariantChange.bind(this));
        });
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this._onSubmit, { capture: true });
      }

      _handleFormSubmit(evt) {
        const form = document.getElementById(this.dataset.formId);
        if (!form || evt.target !== form) return;

        const accessories = this._getCheckedItems();
        if (accessories.length === 0) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        this._addAllToCart(form, accessories);
      }

      _getCheckedItems() {
        return [...this.querySelectorAll('.accessory-checkbox:checked')].map((cb) => {
          const item = cb.closest('.accessory-item');
          const sel = item.querySelector('.accessory-variant-select');
          return {
            id: parseInt(sel ? sel.value : cb.dataset.variantId),
            quantity: 1,
          };
        });
      }

      _addAllToCart(form, accessories) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const btn = form.querySelector('[type="submit"]');
        const spinner = form.querySelector('.loading__spinner');

        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        spinner?.classList.remove('hidden');

        const mainId = parseInt(form.querySelector('[name="id"]').value);
        const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
        const items = [{ id: mainId, quantity: qty }, ...accessories];
        const sections = cart ? cart.getSectionsToRender().map((s) => s.id) : [];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              this._showError(form, response.description);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainId.toString(),
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            cart.setActiveElement?.(document.activeElement);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainId.toString(),
              cartData: response,
            });
            cart.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          });
      }

      _showError(form, message) {
        const productForm = form.closest('product-form');
        const wrapper = productForm?.querySelector('.product-form__error-message-wrapper');
        const msg = wrapper?.querySelector('.product-form__error-message');
        if (wrapper && msg) {
          msg.textContent = message;
          wrapper.removeAttribute('hidden');
        }
      }

      _onVariantChange(evt) {
        const sel = evt.target;
        const item = sel.closest('.accessory-item');
        const opt = sel.options[sel.selectedIndex];

        const img = item.querySelector('.accessory-image');
        if (img && opt.dataset.image) img.src = opt.dataset.image;

        const priceEl = item.querySelector('.accessory-price');
        if (priceEl) {
          const price = parseInt(opt.dataset.price || 0);
          const compare = parseInt(opt.dataset.comparePrice || 0);
          priceEl.innerHTML = this._priceHtml(price, compare);
        }
      }

      _priceHtml(price, compare) {
        const fmt = (cents) => {
          const n = cents / 100;
          return (
            '$' +
            (n % 1 === 0
              ? n.toLocaleString('en-US')
              : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
          );
        };

        if (price === 0) {
          const compareStr = compare ? ` <s class="accessory-price__compare">${fmt(compare)}</s>` : '';
          return `<span class="accessory-price__sale">FREE</span>${compareStr}`;
        }
        if (compare > price) {
          return `<span class="accessory-price__sale">${fmt(price)}</span> <s class="accessory-price__compare">${fmt(compare)}</s>`;
        }
        return `<span class="accessory-price__regular">${fmt(price)}</span>`;
      }
    }
  );
}
